<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="m17.25 9-1.83-2.085.255-2.76-2.708-.615-1.417-2.385L9 2.25 6.45 1.155 5.032 3.54l-2.707.607.255 2.76L.75 9l1.83 2.085-.255 2.767 2.707.615 1.418 2.385L9 15.75l2.55 1.095 1.417-2.385 2.708-.615-.255-2.76L17.25 9Zm-3.383 1.582.195 2.093-2.054.465-1.073 1.807L9 14.115l-1.935.832-1.073-1.807-2.054-.465.195-2.1L2.745 9l1.388-1.59-.196-2.085 2.055-.458L7.066 3.06 9 3.885l1.935-.832 1.072 1.807 2.056.465-.196 2.093L15.255 9l-1.388 1.582Zm-5.617.668h1.5v1.5h-1.5v-1.5Zm0-6h1.5v4.5h-1.5v-4.5Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
